import dayjs from 'dayjs';
import {WEEK_DAY_SORTED_LIST} from 'core/constants';

type TDate = string | Date;
type TFromToProperty = {
    from: TDate;
    to: TDate;
};
export const DATE_TEMPLATES = {
    D: 'D',
    D_MMMM: 'D MMMM',
    DD_MM_YYYY_DOTS: 'DD.MM.YYYY',
    DD_MM_YYYY_HH_MM_SS: 'DD.MM.YYYY HH:mm:ss',
    DD_MMM: 'DD MMM',
    DD_MMMM_HH_MM: 'DD MMMM, HH:mm',
    DD_MMMM_YYYY: 'DD MMMM YYYY',
    HH_MM: 'HH:mm',
} as const;

type TDateTemplates = (typeof DATE_TEMPLATES)[keyof typeof DATE_TEMPLATES];

export const formatDate = (date: TDate, template: TDateTemplates = DATE_TEMPLATES.DD_MMMM_YYYY): string => {
    const dateObj = new Date(date);
    // TODO: посмотреть в сторону date-fns из-за react-datepicker,
    //  но убедиться что не ломает несоответствие версий функционал,
    //  если rdp использует одно, а установлено другое
    return dayjs(dateObj).format(template);
};

export const formatDateWithMonth = (date: TDate) => {
    const dateObj = new Date(date);

    if (dayjs().year() === dayjs(dateObj).year()) {
        return formatDate(date, DATE_TEMPLATES.D_MMMM);
    }

    return formatDate(date, DATE_TEMPLATES.DD_MM_YYYY_DOTS);
};

export const formatDateFromTo = ({from, to}: TFromToProperty) => {
    const fromDate = dayjs(from);
    const toDate = dayjs(to);
    const isOverMonth = Boolean(toDate.diff(fromDate, 'month'));

    return `c ${fromDate.format(isOverMonth ? DATE_TEMPLATES.D_MMMM : DATE_TEMPLATES.D)} по ${toDate.format(
        DATE_TEMPLATES.D_MMMM,
    )}`;
};

export const getTimeInCityWithUTCOffset = (offsetInHours: number) => {
    const now = new Date();
    const utcTime = now.getTime() + now.getTimezoneOffset() * 60000;

    return new Date(utcTime + offsetInHours * 3600000);
};

export const getWeekDayNameFromDate = (date: Date) => {
    return WEEK_DAY_SORTED_LIST[date.getDay()];
};

export const getScheduleHours = (time?: string) => {
    if (!time) {
        return NaN;
    }

    return Number(time.split(':')[0].trim());
};

export const hoursToMinutes = (hours?: number) => {
    if (!hours) {
        return NaN;
    }

    return hours * 60;
};

export const isUserInTime = (userHours: number, openHours: number, closeHours: number) => {
    const userMinutes = hoursToMinutes(userHours);
    const openMinutes = hoursToMinutes(openHours);
    const closeMinutes = hoursToMinutes(closeHours);

    // Если время закрытия меньше времени открытия, значит магазин работает после полуночи
    if (closeMinutes < openMinutes) {
        return userMinutes >= openMinutes || userMinutes < closeMinutes;
    }

    return userMinutes >= openMinutes && userMinutes < closeMinutes;
};
